import type { ReactNode } from 'react'

export type SideBySideProps = {
  left: ReactNode
  right: ReactNode
  leftLabel?: string
  rightLabel?: string
}

export default function SideBySide({ left, right, leftLabel, rightLabel }: SideBySideProps) {
  return (
    <div className="slide-side-by-side" data-archetype="side-by-side">
      <div className="slide-side-by-side__panel slide-side-by-side__panel--left">
        {leftLabel ? <span className="slide-side-by-side__label">{leftLabel}</span> : null}
        <div className="slide-side-by-side__content">{left}</div>
      </div>
      <div className="slide-side-by-side__panel slide-side-by-side__panel--right">
        {rightLabel ? <span className="slide-side-by-side__label">{rightLabel}</span> : null}
        <div className="slide-side-by-side__content">{right}</div>
      </div>
    </div>
  )
}
